
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/[sid]/street",
      function () {
        return require("private-next-pages/buy/[sid]/street.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/[sid]/street"])
      });
    }
  